// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"content-qK58xXi5","errorImg":"errorImg-1LxkKW1G","errorWords":"errorWords-1DcaY5hb","button":"button-3wohCL5Z"};